import { useSelector, useDispatch } from 'react-redux';
import { Button } from '@zoom/react-ui';
import { IconVolumeUpSmall, IconVolumeMuteSmall } from '@zoom/icons-react';
import MusicOptionsList from './MusicOptionsList';
import './SoundButton.css';
import {
  selectIsTimerAudioOn,
  selectedTimerMusicOption,
  selectPreviousSelectedMusicOption,
} from './reducer';
import {
  setTimerAudioState,
  setPreviousSelectedMusicOption,
  setMusicSelectedOption,
} from './actions';
import { useCallback } from 'react';
import useMusicSupportCheckDesktopInMeeting from '../../hooks/Music/useMusicSupportCheckDesktopInMeeting';

export function SoundButton({
  refs,
  source,
  currentAlarmToneSetting = null,
  setCurrentAlarmToneSetting = null,
}) {
  const timerAudioToggleOn = useSelector(selectIsTimerAudioOn);
  const currentSelectedTimerMusicOption = useSelector(selectedTimerMusicOption);
  const previousSelectedMusicOption = useSelector(
    selectPreviousSelectedMusicOption
  );
  const dispatch = useDispatch();
  const [isMusicSupportedDesktopInMeeting, isMusicSupportedDeskopInMainClient] =
    useMusicSupportCheckDesktopInMeeting();

  // when audio is toggled off store the selected music option as previous. Restore it when audio is toggled on.
  const toggleAudioFunction = useCallback(() => {
    if (timerAudioToggleOn) {
      dispatch(setTimerAudioState(false));
      dispatch(
        setPreviousSelectedMusicOption({
          name: currentSelectedTimerMusicOption.name,
          id: currentSelectedTimerMusicOption.id,
        })
      );
      dispatch(setMusicSelectedOption({ name: 'Off', id: -1 }));
    } else {
      dispatch(setTimerAudioState(true));
      dispatch(
        setMusicSelectedOption({
          name: previousSelectedMusicOption.name,
          id: previousSelectedMusicOption.id,
        })
      );
    }
  }, [
    timerAudioToggleOn,
    currentSelectedTimerMusicOption,
    previousSelectedMusicOption,
  ]);

  return (
    <div className='music_timer'>
      <div className='music_alarm'>
        <Button
          type='tertiary'
          startIcon={
            timerAudioToggleOn ? <IconVolumeUpSmall /> : <IconVolumeMuteSmall />
          }
          aria-label={timerAudioToggleOn ? 'Mute Alarm' : 'Unmute Alarm'}
          onClick={() => {
            toggleAudioFunction();
          }}
        >
          Alarm sound
        </Button>
      </div>
      <div className='music_dropdown'>
        {isMusicSupportedDesktopInMeeting ||
        isMusicSupportedDeskopInMainClient ? (
          <MusicOptionsList
            refs={refs}
            source={source}
            currentAlarmToneSetting={currentAlarmToneSetting}
            setCurrentAlarmToneSetting={setCurrentAlarmToneSetting}
          />
        ) : timerAudioToggleOn ? (
          'On'
        ) : (
          'Off'
        )}
      </div>
    </div>
  );
}
